<template>
    <div class="bgc_white">
      <NavbarHeader activeName="product"></NavbarHeader>
      <div v-if="bannerList.length>0" style="background-color: #F5F5F5;">
        <swiperList v-if="bannerList.length>0" :bannerList="bannerList"></swiperList>
      </div>
      <div class="gflex flexcolumn recommend_section">
        <div class="menu_text2">
          <headerTitle englishText="NEW PRODUCTS"
          positiveTitle="本月新品" subheading="为你觅世间好物"></headerTitle>
        </div>
		<template v-if="newMonthlist.length>0">
			<div class="produce_outswiper">
        <div class="produce_swiper">
          <el-carousel type="card" ref="swiper" :autoplay="false" height="783px" arrow="always"
           :initial-index="currentCampus" indicator-position="none" @change="changeCampus">
            <el-carousel-item v-for="(item, index) in newMonthlist" :key="index">
              <div class="brand_swiper gflex flexcolumn">
                <div class="brand_outimg">
                  <img class="brand_img" :class="currentCampus==index?'':'productsfilter'" :src="item.picurl[0]" />
                  <div class="brandcode_out" v-if="currentCampus==index">
                    <div class="recommend_code">
                      <div class="code_inner flexcenter flexcolumn">
                        <el-image class="code_img" style="width: 200px;border-radius: 50%;" ref="QRcode" :src="item.codeUrl" :preview-src-list="[item.codeUrl]">
                        </el-image>
                        <div>扫码查看</div>
                        <div style="display: none;">{{item.codeUrl}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="currentCampus==index?'':'products_tm'">
                  <p class="products_font1">{{item.goodsName}}</p>
                  <p class="products_font2">￥{{item.minCounterPrice}}
                    <span v-if="item.maxCounterPrice>item.minCounterPrice">起</span>
                  </p>
                </div>

              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="categray_arrow categray_arrow_left flexcenter flexcolumn">
          <img src="../../assets/image/arrow_left.png" @click="fnnewMonthPrev()" />
        </div>
        <div class="categray_arrow categray_arrow_right flexcenter flexcolumn">
          <img src="../../assets/image/arrow_right.png" @click="fnnewMonthNext()" />
        </div>
			</div>
			<div class="produce_smallswiper">
			  <van-swipe indicator-color="#D8BE80">
			    <van-swipe-item v-for="(item, index) in newMonthlist" :key="index">
            <div @click="watchcodeUrl(item.codeUrl)">
              <el-image style="width: 345px;height: 410px;" :src="item.picurl[0]" fit="cover" ></el-image>
            </div>
            <p class="products_font1">{{item.goodsName}}</p>
            <p class="products_font2">￥{{item.minCounterPrice}}
              <span v-if="item.maxCounterPrice>item.minCounterPrice">起</span>
            </p>
          </van-swipe-item>
			  </van-swipe>
			</div>
		</template>
        <div class="menu_text">
          <headerTitle englishText="SELECT GOOD THINGS"
          positiveTitle="甄选好物" subheading="用实力营造美好的家"></headerTitle>
        </div>
        <div class="product_categray">
          <div class="categray_wrap">
            <ul class="flex categray_ul" :style="[{marginLeft: cateLeft+'px'}]">
              <li v-for="(item, index) in categrayList" :key="index"
                :class="cateCurrent== index?'proactive':''" @click="cateSelect(item, index)">
                  <div>{{item.groupName}}</div>
              </li>
            </ul>
          </div>
            <div class="categray_arrow categray_arrow_left flexcenter flexcolumn" v-if="showarrowLeft">
              <img src="../../assets/image/arrow_left.png" @click="fnPrev()" />
            </div>
            <div class="categray_arrow categray_arrow_right flexcenter flexcolumn" v-if="showarrowRight">
              <img src="../../assets/image/arrow_right.png" @click="fnNext()" />
            </div>
        </div>
		<div class="product_phonecategray" :style="[{width: windowWidth+'px'}]">
			<van-tabs type="card" @click="vancateSelect"
        background="#fff" color="#DCC691" title-active-color="#fff">
			  <van-tab v-for="(item, index) in categrayList" :title="item.groupName">
			  </van-tab>
			</van-tabs>
		</div>
        <ul class="goods_wrap" v-if="goodsList.length>0">
          <li v-for="(item, index) in goodsList" :key="index">
            <div class="goodsout_url">
              <img class="goods_url" @click="watchcodeUrl(item.codeUrl)" :src="item.picurl[0]" />
              <div class="recommend_code">
                <div class="code_inner flexcenter flexcolumn">
                  <el-image class="code_img" style="width: 180px;border-radius: 50%;" ref="QRcode" :src="item.codeUrl" :preview-src-list="[item.codeUrl]">
                  </el-image>
                  <div>扫码查看</div>
                  <div style="display: none;">{{item.codeUrl}}</div>
                </div>
              </div>
            </div>
            <div class="goods_name gobyndsingle">{{item.goodsName}}</div>
            <p class="goods_price">¥{{item.minCounterPrice}}
              <span v-if="item.maxCounterPrice>item.minCounterPrice">起</span>
            </p>
          </li>
        </ul>
        <div v-else style="font-size: 16px;color: #999;text-align: center;padding: 20px;">暂无商品～</div>
      </div>

      <footerBar></footerBar>

      <van-popup v-model="showScancode" closeable position="center"
        :style="{ borderRadius: '10px' }">
        <div class="scancode_wrap flexcenter flexcolumn">
          <div class="codeimg_inner">
            <img class="codeimg" :src="qrCodeurl" />
          </div>
          <p class="codetext">扫码查看商品</p>
        </div>
      </van-popup>
    </div>
</template>
<script>
	import { goodsGroupbaseapi, createQrCodewxapi,
	 basebannerListapi, groupbaseapi, newGoodsbaseapi
	} from "@/api/apilist/commonApi";
  import headerTitle from "@/components/assembly/headerTitle.vue";
  import swiperList from "@/components/assembly/swiperList.vue";
  import footerBar from "@/components/footerBar/footerBar.vue";
  import NavbarHeader from "@/components/NavbarHeader/NavbarHeader.vue";
  export default {
    components: {
      NavbarHeader, footerBar, swiperList, headerTitle
    },
    data() {
      return {
        shownewsDetail: true,
		groupId: undefined,
        bannerList: [],
		newMonthlist: [],
		goodsList: [],
        currentCampus: 0,
        categrayList: [],
        cateCurrent: 0,
        cateLeft: 0,
        cateTotalwidth: 0,
        showarrowLeft: false,
        showarrowRight: true,
        windowWidth: 1200,
        qrCodeurl: '',
        showScancode: false,
      };
    },
    created() {
		this.getbasebannerList();
		this.getgroupList();
    },
    activated(){
      this.getnewGoodsbase();
    },
    mounted(){
      this.windowWidth = document.documentElement.clientWidth;
      window.addEventListener('resize', () => { //监听浏览器窗口大小改变
               //浏览器变化执行动作
        this.windowWidth = window.innerWidth;
      });
    },
    methods: {
      // 查看二维码
      watchcodeUrl(code){
        this.qrCodeurl = code;
        this.showScancode = true;
      },
      fnnewMonthPrev(){
        this.$refs.swiper.prev();
      },
      fnnewMonthNext(){
        this.$refs.swiper.next();
      },
      getbasebannerList() {
        basebannerListapi({ bannerType: 2 }).then(res=>{
          this.bannerList = res.data;
        })
      },
      getnewGoodsbase() {
        newGoodsbaseapi().then(res=>{
          if(res.data){
            res.data.forEach((item)=>{
              item.codeUrl = '';
              if(item.goodsGallery){
                item.picurl = item.goodsGallery.split(',');
              }
            })
          }
          this.newMonthlist = res.data;
          for(let i=0;i<this.newMonthlist.length;i++){
            this.getcreateQrCodewx(this.newMonthlist[i].goodsId, 2);
          }
        })
      },
      getgroupList() {
        groupbaseapi().then(res=>{
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].groupName == '本月新品'){
                res.data.splice(i,1);
                i--;
            }
          }
          this.categrayList = res.data;
          this.groupId = res.data[0].groupId;
          this.getgoodsGroupbase();
        })
      },
      getgoodsGroupbase() {
        goodsGroupbaseapi({ groupId: this.groupId }).then(res=>{
          if(res.data){
            res.data.forEach((item)=>{
              if(item.goodsGallery){
                item.picurl = item.goodsGallery.split(',')
              }
            })
            this.goodsList = res.data;
            for(let i=0;i<this.goodsList.length;i++){
              this.getcreateQrCodewx(this.goodsList[i].goodsId, 1);
            }
          }
        })
      },

        getcreateQrCodewx(goodsId, val) {
          createQrCodewxapi(
          {
            codeType: "toC/goods/goodsDetails",
            parameterValue: '&goodsId='+goodsId,
          }).then(res => {
            if(val==1){
              this.goodsList.forEach((item)=>{
                if(goodsId==item.goodsId){
                  item.codeUrl = "data:image/gif;base64," + res.data;
                  this.$forceUpdate()
                }
              })
            }else{
              this.newMonthlist.forEach((item)=>{
                if(goodsId==item.goodsId){
                  item.codeUrl = "data:image/gif;base64," + res.data;
                  this.$forceUpdate()
                }
              })
            }

          })
        },
      changeCampus(e){
        this.currentCampus = e;
      },
      vancateSelect(val){
        console.log(val)
        this.categrayList.forEach((item, index)=>{
          if(val==index){
            this.groupId = item.groupId;
          }
        })
        this.getgoodsGroupbase();
      },
      cateSelect(item, index){
        this.cateCurrent = index;
        this.groupId = item.groupId;
        this.getgoodsGroupbase();
      },
      fnPrev(){
        if(this.cateLeft>= -169){
          this.cateLeft = 0;
          this.showarrowRight = true;
          this.showarrowLeft = false;
          this.cateTotalwidth = 0;
        }else{
          this.cateLeft = this.cateLeft + 169;
        }
      },
      fnNext(){
        let mylength = this.categrayList.length - 7;
        if(this.cateTotalwidth<mylength){
          this.cateTotalwidth +=1;
          this.cateLeft = this.cateLeft-169;
        }else{
          this.showarrowRight = false;
        }
        this.showarrowLeft = true;
      },

    }
  };
</script>

<style scoped lang="less">
  @media screen and (max-width: 480px){
    .scancode_wrap{
      width: 300px;
      height: 320px;
      border-radius: 10px;
      text-align: center;
      .codeimg_inner{
        padding: 10px;
        border-radius: 50%;
        width: 195px;
        height: 195px;
        margin: 0 auto;
        background-color: #fff;
        overflow: hidden;
      }
      .codeimg{
        width: 180px;
        height: 180px;
      }
      .codetext{
        font-size: 18px;
        margin-top: 22px;
      }
    }
    .recommend_section{
      padding: 0 15px;
    }
	.produce_outswiper{display: none;}
	.produce_swiper{display: none;}
    .menu_text{margin: 47px auto 27px;}
    .menu_text2{margin: 52px auto 27px;}
    .produce_smallswiper{
      width: 100%;
	  height: 495px;
      text-align: center;
      font-weight: bold;
      .products_font1{font-size: 16px;margin-top: 20px;}
      .products_font2{font-size: 16px;color: #D8BE80;}
      ::v-deep .van-swipe__indicators{bottom: 0px;}
	  ::v-deep .van-swipe{height: 100%;}
	  ::v-deep .van-swipe__indicator{width: 10px;height: 10px;}
	  ::v-deep .van-swipe__indicator{background-color: #989898;opacity: 1;}
    }
    .product_phonecategray{margin-bottom: 30px;overflow: hidden;height: 42px;
      ::v-deep .van-tabs__nav--card{border: none;}
      ::v-deep .van-tabs__nav--card .van-tab{
        width: 80px;
        padding: 0;
        margin-right: 12px;border-radius: 20px;border: 1px solid #D8BE80;}
    }
    .product_categray{
      display: none;
    }
    .recommend_code{display: none;}
    .goods_wrap{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding-bottom: 30px;

      li{
        width: 50%;
        padding-bottom: 15px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .goods_url{
          width: 100%;
          border-radius: 2px;display: block;
        }
        .goods_name{width: 168px;font-size: 14px;font-weight: bold;margin: 10px 0 14px;}
        .goods_price{width: 168px;color: #DCC691;font-size: 16px;font-weight: bold;}
      }
      li:nth-child(odd){padding-right: 7px;}
      li:nth-child(even){padding-left: 7px;}
    }
  }
  @media screen and (min-width: 481px){
    .products_font1{
      font-size: 20px;
      padding-top: 5px;
      line-height: 40px;
    }
    .products_font2{font-size: 18px;line-height: 20px;}
    .recommend_section{
      width: 1200px;
      margin: 0 auto;
    }
    .product_phonecategray{display: none;}
    .produce_smallswiper{display: none;}
    .menu_text{margin: 119px auto 47px;}
    .menu_text2{margin: 69px auto 47px;}
    .product_categray{
      width: 100%;
      height: 42px;
      margin-bottom: 50px;
      overflow-y: hidden;
      font-size: 18px;
      text-align: center;
      position: relative;
      .categray_arrow{
        width: 36px;height: 100%;background-color: #FFFFFF;position: absolute;
        img{width: 16px;height: 30px;cursor: pointer;}
      }
      .categray_arrow_left{left: 0;padding-right: 20px;}
      .categray_arrow_right{right: 0;padding-left: 20px;}
      .categray_wrap{
        width: 1200px;
        overflow-x: scroll;
        white-space: nowrap;
        position: absolute;
        padding-bottom: 10px;
        left: 0;
        top: 0;
        .categray_ul{
          transition: 0.3s;
          li{
            cursor: pointer;
            display: block;
            line-height: 40px;
            color: #DCC691;
            border: 1px solid #DCC691;
            border-radius: 20px;
            margin-right: 49px;
            div{
              width: 120px;
              height: 40px;
            }
          }
          .proactive{color: #fff;background-color: #DCC691;}
        }
      }
    }
    .recommend_code{
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.6);
      color: #fff;
      text-align: center;
      border-radius: 5px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
      display: none;
      font-size: 18px;
      .code_inner{width: 100%;height: 100%;}
      .code_img{
        border-radius: 50%;
        margin-bottom: 20px;
      }
    }
    .goods_wrap{
      display: flex;
      flex-wrap: wrap;
      width: 1228px;
      margin-left: 27px;
      padding-bottom: 80px;

      li{
        width: 285px;
        padding-bottom: 23px;
        margin-right: 20px;
        cursor: pointer;
        position: relative;
        .goodsout_url{position: relative;height: 380px;}
        .goods_url{
          width: 100%;
          height: 380px;
          border-radius: 5px;
        }
        .goods_name{font-size: 20px;font-weight: bold;margin: 10px 0 14px;}
        .goods_price{color: #DCC691;font-size: 18px;font-weight: bold;}
      }
      li:hover .recommend_code{display: block;}
    }
  }
  .brand_outimg{position: relative;height: 715px;}
  .brand_swiper:hover .brandcode_out .recommend_code{display: block;}
  .recommend_section{
    background-color: #fff;
	.produce_outswiper{position: relative;width: 100%;
		.categray_arrow{top: 0;
		  width: 36px;height: 100%;background-color: #FFFFFF;position: absolute;
		  img{width: 27px;height: 50px;cursor: pointer;}
		}
		.categray_arrow_left{left: 0;}
		.categray_arrow_right{right: 0;}
	}
    .produce_swiper{
      // border: 1px solid red;
      width: 100%;position: relative;padding-bottom: 11px;
      ::v-deep .el-carousel__item--card{width: 500px;}
      ::v-deep .el-carousel--horizontal{width: 1000px;height: 783px;margin: 0 auto;}
      ::v-deep .el-carousel__item{display: flex;justify-content: center;}
      // 这里把左右箭头换了，更贴近UI效果
      ::v-deep .el-carousel__arrow--left{
        right: -200px;
        left: auto;
        background-image: url(../../assets/image/arrow_right.png);
        .el-icon-arrow-left{opacity: 0;}
      }
      ::v-deep .el-carousel__arrow--right{
        left: -100px;
        right: auto;
        background-image: url(../../assets/image/arrow_left.png);
        .el-icon-arrow-right{opacity: 0;}
      }
      ::v-deep .el-carousel__arrow{
        width: 27px;
        height: 50px;
        border-radius: 0px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-color: #FFFFFF;
      }
    }


    .products_tm{opacity: 0;}

    // ::v-deep .el-carousel__indicators{display: none;}
  }
  .brand_swiper{
    width: 500px;
    height: 100%;
    text-align: center;
    position: relative;
    .brand_img{
      width: 100%;
      height: 715px;
      border-radius: 5px;
    }
    .products_font1{
      font-weight: bold;
    }
    .products_font2{color: #DCC691;font-weight: bold;}
    .productsfilter{
      filter: blur(2px) brightness(70%);
    }
  }
</style>
